import { useQuery } from "react-query";
import { internalApi } from "@/react/helpers/urlHelpers";

export const usePlanFeatureFlags = (reactQueryOptions = {}) =>
  useQuery(internalApi.planFeatureFlags.show(), reactQueryOptions);
